/* eslint-disable */

import React, { Component } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import domains from '../../containers/Domains';

import { Wrapper, Media, MediaFacebook } from '../../components/share';

const Container = styled.div`
  overflow-x: hidden;
`;

class AdShareTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      media: []
    };

    localStorage.setItem('Shared', false);

    this.media = [
      {
        instagram: {
          caption: {
            text:
              'A B C D E F G H I J K L M N O P Q R S T U V W X Y Z A B C D E F G H I J K L M N O P Q R S T U V W X Y Z A B C D E F G H I J K L M N O P Q R S T U V W X Y Z A B C D E F G H I J K L M N O P Q R S T U V W X Y Z'
          },
          images: {
            standard_resolution: {
              url:
                'https://instagram.fmid1-1.fna.fbcdn.net/vp/a692faf6ea7203ca9af3c76c974f4de6/5C691D87/t51.2885-15/e35/43820720_247678729252575_1650394764093908825_n.jpg'
            }
          },
          created_time: '1540489060',
          likes: { count: 0 },
          comments: { count: 0 },
          link: 'https://www.instagram.com/p/Bo94OpMn5hR/',
          user: {
            full_name: 'Constellation Test',
            username: 'constellation_test',
            profile_picture:
              'https://instagram.fkwi2-1.fna.fbcdn.net/vp/a8539c22ed9fec8e1c43b538b1ebfd1d/5C5A1A7A/t51.2885-19/11906329_960233084022564_1448528159_a.jpg'
          }
        },
        facebook: {
          caption: {
            text:
              'A B C D E F G H I J K L M N O P Q R S T U V W X Y Z A B C D E F G H I J K L M N O P Q R S T U V W X Y Z A B C D E F G H I J K L M N O P Q R S T U V W X Y Z A B C D E F G H I J K L M N O P Q R S T U V W X Y Z'
          },
          images: {
            standard_resolution: {
              url:
                'https://instagram.fmid1-1.fna.fbcdn.net/vp/a692faf6ea7203ca9af3c76c974f4de6/5C691D87/t51.2885-15/e35/43820720_247678729252575_1650394764093908825_n.jpg'
            }
          },
          created_time: '1540489060',
          likes: { count: 0 },
          comments: { count: 0 },
          link: 'https://www.facebook.com/Constellation-Dev-1708678142759119/',
          user: {
            full_name: 'Constellation Dev',
            username: 'Constellation-Dev',
            profile_picture:
              'https://scontent.fmid1-1.fna.fbcdn.net/v/t1.0-9/18425001_1708698422757091_2517798846035995288_n.png?_nc_cat=103&_nc_ht=scontent.fmid1-1.fna&oh=05f84305d679b67f2e101b4542ce21ab&oe=5C4DDDB6'
          }
        }
      }
    ];
  }

  componentDidMount = async () => {
    this.setState({ media: this.media });
  };

  getData = async (code) => {
    try {
      const res = await axios(
        `${domains[window.location.hostname]}/service/instagram?code=${code}`
      );
      console.log(res);
      return res;
    } catch (e) {
      console.log(e.response);
    }
  };

  render() {
    return (
      <Container className="container">
        <h3>Constellation Test</h3>
        {this.state.media.length > 0 &&
          this.state.media.map((post, i) => <Media key={i} item={post} />)}
      </Container>
    );
  }
}

export default AdShareTemplate;



// WEBPACK FOOTER //
// ./src/screens/AdShare/Template.js